"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _productHelper = require("../../../../../helpers/productHelper");
var _buySellSelectors = require("../../../../../redux/selectors/buySellSelectors");
var _BuySellPresetValuesRowsComponent = _interopRequireDefault(require("./BuySellPresetValuesRowsComponent"));
var _instrumentPositionSelectors = require("../../../../../redux/selectors/instrumentPositionSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var form = state.form;
  var formObj = form.buySell || {
    values: {}
  };
  var dealValues = (0, _buySellSelectors.getPriceDataForPresetValuesSelector)(state, formObj.values.side);
  var selectedInstrument = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state);
  var presetValues = dealValues.map(function (deal) {
    return {
      key: deal.price,
      amountRadio: deal.price.toString(),
      value1: (0, _productHelper.getBalanceWithProductSymbol)(selectedInstrument.Product2Symbol, deal.price),
      value2: deal.quantity
    };
  });
  return {
    isBuySide: (0, _buySellSelectors.isBuySideBuySellFormSelector)(state),
    dealValues: presetValues
  };
};
var mapDispatchToProps = {
  setAmount: function setAmount(amount) {
    return (0, _reduxForm.change)('buySell', 'amountRadio', amount);
  }
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_BuySellPresetValuesRowsComponent["default"]);